import { Alert } from "antd";

export const OwnerAlert = () => (
  <Alert
    message="Only P0 owners may install integrations"
    icon
    type="warning"
  />
);
